export default "__VITE_ASSET__CPkoA21e__"